import { SPHERE } from '@/constants/object';
import * as THREE from 'three';
import { BaseObject, applyProperties } from './base';

export class Sphere extends BaseObject {
  constructor() {
    super(
      new THREE.SphereGeometry(SPHERE.RADIUS, SPHERE.WIDTH_SEGMENTS, SPHERE.HEIGHT_SEGMENTS),
      new THREE.MeshStandardMaterial({ color: SPHERE.COLOR })
    );

    this.radius = SPHERE.RADIUS;
    this.widthSegments = SPHERE.WIDTH_SEGMENTS;
    this.heightSegments = SPHERE.HEIGHT_SEGMENTS;
    this.phiStart = SPHERE.PHI_START;
    this.phiLength = SPHERE.PHI_LENGTH;
    this.thetaStart = SPHERE.THETA_START;
    this.thetaLength = SPHERE.THETA_LENGTH;

    this.getOutline();

    this.updateGeometry = () => {
      this.geometry.dispose();
      this.geometry = new THREE.SphereGeometry(
        this.radius,
        this.widthSegments,
        this.heightSegments,
        this.phiStart,
        this.phiLength,
        this.thetaStart,
        this.thetaLength
      );
      this.getOutline();
    };
    this.applyProperties = (properties) => {
      applyProperties(this, properties, false);
      let needsUpdate = false;

      if ('radius' in properties && properties.radius !== this.radius) {
        this.userData.data.radius = properties.radius;
        this.radius = properties.radius;
        needsUpdate = true;
      }
      if ('widthSegments' in properties && properties.widthSegments !== this.widthSegments) {
        this.userData.data.widthSegments = properties.widthSegments;
        this.widthSegments = properties.widthSegments;
        needsUpdate = true;
      }
      if ('heightSegments' in properties && properties.heightSegments !== this.heightSegments) {
        this.userData.data.heightSegments = properties.heightSegments;
        this.heightSegments = properties.heightSegments;
        needsUpdate = true;
      }
      if ('phiStart' in properties && properties.phiStart !== this.phiStart) {
        this.userData.data.phiStart = properties.phiStart;
        this.phiStart = properties.phiStart;
        needsUpdate = true;
      }
      if ('phiLength' in properties && properties.phiLength !== this.phiLength) {
        this.userData.data.phiLength = properties.phiLength;
        this.phiLength = properties.phiLength;
        needsUpdate = true;
      }
      if ('thetaStart' in properties && properties.thetaStart !== this.thetaStart) {
        this.userData.data.thetaStart = properties.thetaStart;
        this.thetaStart = properties.thetaStart;
        needsUpdate = true;
      }
      if ('thetaLength' in properties && properties.thetaLength !== this.thetaLength) {
        this.userData.data.thetaLength = properties.thetaLength;
        this.thetaLength = properties.thetaLength;
        needsUpdate = true;
      }

      if (needsUpdate) this.updateGeometry();
    };
  }
}
